import { Injectable } from '@angular/core';

@Injectable()
export class _testNotesGlobals {
  public NOTE_GROUP_ID: string = 'FBEF5F71-28E3-E611-8289-001018350ACD';
  public NOTE_GROUP_OBJECTID: string = 'C7EF5F71-28E3-E611-8289-001018350ACD';
  public NOTE_GROUP_PATIENTID: string = 'C7EF5F71-28E3-E611-8289-001018350ACD';
  public NOTE_GROUP_OBJECTYPE: string = 'dataPatient';
}
